import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';
import { useAppUpdate } from './useAppUpdate';

/**
 * 「有新版本」横幅（CR-067）。
 *
 * 挂在手机端外壳顶上，样式和位置照上传状态条（`QueueBar`）：一条窄的、能点开的提示，
 * **不挡打卡、不挡底部 Tab、不做全屏遮罩** —— 工人正要打卡时被一个更新弹窗拦住是最糟的体验。
 * 关掉之后这一版不再提示，出了更新的版本照旧提示。
 */
export function UpdateBanner() {
  const { t, i18n } = useTranslation();
  const { release, state, start, dismiss } = useAppUpdate();

  if (!release) return null;

  const message =
    state === 'downloading'
      ? t('update.downloading')
      : state === 'installing'
        ? t('update.installing')
        : state === 'needPermission'
          ? t('update.needPermission')
          : state === 'failed'
            ? t('update.failed')
            : t('update.available');
  const busy = state === 'downloading';

  return (
    <div className="mb-3 rounded-md border border-brand-200 bg-brand-50 px-3 py-2.5 text-body text-brand-700">
      <p className="font-medium">{message}</p>
      {/* 副标题给「构建日期 + 多大」，不给 versionCode：那是个七位数的分钟数，
          工人看两串数字读不出任何信息，他要知道的是这一下要下多少流量 */}
      <p className="mt-0.5 text-caption opacity-80">
        {t('update.meta', {
          date: new Date(release.builtAt).toLocaleDateString(i18n.language, {
            month: 'numeric',
            day: 'numeric',
          }),
          size: (release.sizeBytes / (1024 * 1024)).toFixed(1),
        })}
      </p>

      {state !== 'installing' && (
        // 工人端的按钮一律 56px：戴着手套点（约束 10）
        <div className="mt-2 grid grid-cols-2 gap-2">
          <Button block loading={busy} onClick={start}>
            {t('update.action')}
          </Button>
          <Button variant="secondary" block disabled={busy} onClick={dismiss}>
            {t('update.later')}
          </Button>
        </div>
      )}
    </div>
  );
}
